import {
    getClientApi,
    getEmailVerificationApi,
    getExecutorApi,
} from '@/core/api/generatedApiClient';
import type { EmailVerificationStatusResponse } from '@/core/generated/api';
import { rethrowHandledApiError } from '@/core/api/rethrowHandledApiError';
import type { ProfileEmailBindingRequest } from '../model/types';

/** Управляет подтверждением почты выбранного профиля */
export const emailVerificationService = {
    /** Получает состояние подтверждения и паузу до повторной отправки */
    async getStatus(appUserId: string): Promise<EmailVerificationStatusResponse> {
        try {
            const response = await getEmailVerificationApi()
                .apiV1EmailVerificationStatusGet({
                    appUserId,
                });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Привязывает адрес и запрашивает письмо подтверждения */
    async bindEmail(binding: ProfileEmailBindingRequest): Promise<void> {
        try {
            if (binding.kind === 'client') {
                await getClientApi().setClientEmail({ setClientEmailRequest: binding.request });
            } else {
                await getExecutorApi().setExecutorEmail({ setExecutorEmailRequest: binding.request });
            }
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },
};
